import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, b as _extends } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_arrayReduce-35053fa6.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import { _ as _map } from './map-651e82c0.js';
import './join-15b17329.js';
import './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import { Text } from './Typographies.js';
import './index-f96168ba.js';
import { g as getSpacesAsCss } from './getSpacesAsCSS-2c03c4c1.js';
import './_hasUnicode-6e5e26e7.js';
import { _ as _isString } from './isString-30e5fe84.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n\n  position: relative;\n  padding: ", ";\n\n  // Remove default OS appearance\n  appearance: none;\n  &::-ms-expand {\n    display: none;\n  }\n\n  &:focus {\n    outline: none;\n    border-color: ", ";\n    box-shadow: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var borders = css(["border:", " solid ", ";border-radius:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.components.select.select.borders.width;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.components.select.select.colors.border;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.components.select.select.borders.radius;
});
var colors = css(["color:", ";background-image:linear-gradient( 45deg,transparent 50%,", " 50% ),linear-gradient( 135deg,", " 20%,transparent 50% ),linear-gradient( to right,", ",", " );background-position:calc( 100% - calc(90 * ", " / 100 / 2) + calc(", " / 4) ) 50%,calc( 100% - calc(90 * ", " / 100 / 2) + calc(3 * ", " / 4) ) 50%,calc( 100% - calc(75 * ", " / 100) ) ", ";background-size:", " calc(", " / 2),", " calc(", " / 2),", " calc(100% - calc(2 * ", "));background-size:", ";background-repeat:no-repeat;background-color:", ";"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.components.select.select.colors.text;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.components.select.select.colors.arrow;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.components.select.select.colors.arrow;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.components.select.select.colors.separator;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.components.select.select.colors.separator;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.components.select.select.spaces.paddingRight;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.components.select.select.sizes.arrowWidth;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.components.select.select.spaces.paddingRight;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.components.select.select.sizes.arrowWidth;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.components.select.select.spaces.paddingRight;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.components.select.select.spaces.paddingTop;
}, function (_ref15) {
  var theme = _ref15.theme;
  return theme.components.select.select.sizes.arrowHeight;
}, function (_ref16) {
  var theme = _ref16.theme;
  return theme.components.select.select.sizes.arrowWidth;
}, function (_ref17) {
  var theme = _ref17.theme;
  return theme.components.select.select.sizes.arrowHeight;
}, function (_ref18) {
  var theme = _ref18.theme;
  return theme.components.select.select.sizes.arrowWidth;
}, function (_ref19) {
  var theme = _ref19.theme;
  return theme.components.select.select.sizes.separatorWidth;
}, function (_ref20) {
  var theme = _ref20.theme;
  return theme.components.select.select.spaces.paddingBottom;
}, function (_ref21) {
  var multiple = _ref21.multiple;
  return multiple ? '0' : '';
}, function (_ref22) {
  var theme = _ref22.theme;
  return theme.components.select.select.colors.background;
});
var sizes = css(["max-height:", ";height:", ";width:", ";"], function (_ref23) {
  var theme = _ref23.theme;
  return theme.components.select.select.sizes.minHeight;
}, function (_ref24) {
  var theme = _ref24.theme;
  return theme.components.select.select.sizes.height;
}, function (_ref25) {
  var theme = _ref25.theme;
  return theme.components.select.select.sizes.width;
});
var StyledSelect = styled(Text.withComponent('select'))(_templateObject(), borders, colors, sizes, function (_ref26) {
  var theme = _ref26.theme;
  return getSpacesAsCss(theme.components.select.select.spaces, 'padding');
}, function (_ref27) {
  var theme = _ref27.theme;
  return theme.components.select.select.colors.borderFocus;
}, function (_ref28) {
  var theme = _ref28.theme;
  return theme.components.select.select.boxShadows.boxShadowFocus;
});

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A select field.
 *
 */

var Select = function Select(_ref) {
  var id = _ref.id,
      isMulti = _ref.isMulti,
      name = _ref.name,
      onChange = _ref.onChange,
      options = _ref.options,
      size = _ref.size,
      value = _ref.value,
      defaultValue = _ref.defaultValue,
      rest = _objectWithoutProperties(_ref, ["id", "isMulti", "name", "onChange", "options", "size", "value", "defaultValue"]);

  var optionsElements = _map(options, function (elt) {
    var value = _isString(elt) ? elt : elt.id || elt.name;
    var key = _isString(elt) ? elt : elt.id || elt.name;
    var name = _isString(elt) ? elt : elt.name || elt.id;
    return React.createElement("option", {
      value: value,
      key: key
    }, name);
  });
  /*
   * React will consider the select as controlled even if value is null.
   */


  var finalValue = value === null ? undefined : value;
  return React.createElement(StyledSelect, _extends({
    id: id,
    name: name,
    onChange: onChange,
    multiple: isMulti,
    size: size,
    value: finalValue,
    defaultValue: defaultValue
  }, rest), optionsElements);
};

Select.defaultProps = {
  isMulti: false,
  name: '',
  onChange: null,
  size: 0,
  value: null,
  defaultValue: null
};
Select.propTypes = {
  /**
   * The id of the select.
   */
  id: PropTypes.string.isRequired,

  /**
   * A boolean which is true if we allow multiple selection.
   */
  isMulti: PropTypes.bool,

  /**
   * Name of the component.
   */
  name: PropTypes.string,

  /**
   * Function which is called when the value selected has changed.
   */
  onChange: PropTypes.func,

  /**
   * The options of the select.
   */
  options: PropTypes.array.isRequired,

  /**
   * Number of elements displayed.
   */
  size: PropTypes.number,

  /**
   * The value to use as a controlled component.
   */
  value: PropTypes.any,

  /**
   * The default value to use as an uncontrolled component.
   */
  defaultValue: PropTypes.any
};
/** @component */

var Select$1 = styled(Select)(_templateObject$1());

export default Select$1;
